<template>
  <div class="container" :style="`width: ${itemWidth}px;`">
    <div class="logo">
      <img :src="option.logo" alt="">
    </div>
    <!-- <div class="plano">
      Plano <br>
      <span :style="{ color: chatbotColors.sentMessage.bg }">{{ option.nome }}</span>
    </div> -->
    <!-- <div class="descricao">{{ option.descricao }}</div> -->
    <div class="total" :style="{ color: chatbotColors.sentMessage.bg }">{{ option.valor }} <span>/ {{ option.valor_descricao }}</span></div>
    <!-- <div class="detalhes">
      Abrangência: <strong>{{ option.abrangencia }}</strong> <br>
      Coparticipação: <strong>{{ option.coparticipacao }}</strong>
    </div> -->
    <div v-if="option.coberturas.length" class="coberturas-title">COBERTURAS</div>
    <div v-if="option.coberturas.length" class="coberturas-content">
      <table>
        <tr v-for="(cobertura, idy) in option.coberturas" :key="`${idx}-cobertura-${idy}`">
          <td><b>{{ cobertura.label }}</b></td>
          <td width="1" style="white-space: nowrap;">{{ cobertura.value }}</td>
        </tr>
      </table>
    </div>
    <!-- <div class="outras-descricoes">
      <span v-for="descricao in option.outras_descricoes" :key="descricao">
        <strong>{{ descricao }}</strong>
      </span>
    </div> -->
    <div class="options">
      <a href="#" class="botao" :disabled="optionSelected" @click="$emit('selectOption', option)" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">QUERO CONTRATAR</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbotColors: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    itemWidth: {
      type: Number,
      required: true
    },
    optionSelected: {
      type: Object
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin: 10px;
  padding: 15px;
  background: white;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 12px;
}
.logo {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 130px;
    max-height: 60px;
  }
}
.plano {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.7rem;
  line-height: 14px;
  text-align: center;

  span {
    font-size: 1.1rem;
  }
}
.descricao {
  margin-top: 10px;
  font-size: 0.7rem;
  text-align: center;
}
.total {
  margin-top: 5px;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: -1px;
  text-align: center;
  padding: 5px;
  border-radius: 10px;
  background: #f0faf9;

  span {
    font-size: 0.8rem;
  }
}
.coberturas-title {
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #777;
}
.coberturas-content {
  tr:nth-of-type(odd) {
    background-color: #ddd;
  }
  td {
    font-size: 0.7rem;
    border: 1px solid white;
    padding: .4rem;
    vertical-align: top;
  }
}
.detalhes {
  margin-top: 10px;
  font-size: 0.7rem;
  color: #777;
  text-align: center;

  strong {
    font-weight: 600;
  }
}
.outras-descricoes {
  margin-top: 10px;
  font-size: 0.7rem;
  color: #777;
  text-align: center;

  strong {
    width: 100%;
    display: block;
    font-weight: 600;
  }
}
.options {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .botao {
    display: inline-block;
    padding: 8px 15px;
    border: 0;
    border-radius: 20px;
    font-size: 0.8rem;
    text-decoration: none;
    text-align: center;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }

    &:disabled {
      opacity: .3;
      cursor: not-allowed;
      pointer-events: all !important;
    }
  }
}
</style>
